module.exports = __webpack_public_path__ + "static/media/keep.a0a46552.svg";